import styled from "styled-components";

export const SettingBaseWrapper = styled.div<{ $theme?: string }>`
  width: 100%;
`;


export const HeaderTitleWrapper = styled.div<{ $theme?: string }>`
  gap: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -6px;
`;